import DashboardClinicalRosterTable from "./DashboardClinicalRosterTable";

export default DashboardClinicalRosterTable;
